import React, { useEffect, useState } from 'react';
import { Switch } from 'react-router-dom';
import AppRoute from '../routes/route';
import VerticalLayout from '../components-old/VerticalLayout/';
import NonAuthLayout from './NonAuthLayout';
import { authProtectedRoutes as oldAuthProtectedRoutes, publicRoutes as oldPublicRoutes } from '../routes/index-old';

const DATA_ATTRS = ['sidebar', 'topbar', 'layout', 'layout-size', 'layout-scrollable'];
const BODY_CLASSES = ['sidebar-enable', 'vertical-collpsed'];
const THEME_URL = '/old/theme.css?v=5';

export default function OldApp() {
    const [cssReady, setCssReady] = useState(false);

    useEffect(() => {
        const link = document.createElement('link');
        link.id = 'old-theme';
        link.rel = 'stylesheet';
        link.href = THEME_URL;
        link.onload = () => setCssReady(true);
        document.head.appendChild(link);

        const root = document.getElementById('old-root');

        function syncToRoot() {
            if (!root) return;
            DATA_ATTRS.forEach(attr => {
                const val = document.body.getAttribute('data-' + attr);
                if (val !== null) root.setAttribute('data-' + attr, val);
            });
            BODY_CLASSES.forEach(cls => {
                root.classList.toggle(cls, document.body.classList.contains(cls));
            });
        }

        syncToRoot();

        const obs = new MutationObserver(syncToRoot);
        obs.observe(document.body, {
            attributes: true,
            attributeFilter: ['class', ...DATA_ATTRS.map(a => 'data-' + a)],
        });

        return () => {
            document.getElementById('old-theme')?.remove();
            obs.disconnect();
        };
    }, []);

    if (!cssReady) return null;

    return (
        <div
            id="old-root"
            data-sidebar="dark"
            data-topbar="light"
            data-layout="vertical"
        >
            {/* Reseta tokens do novo admin que cascateiam para dentro de #old-root */}
            <style>{`
                #old-root {
                    --Roxo-500: #5664d2;
                    --roxo-500: #5664d2;
                    --font-family: "Inter", sans-serif;
                    --radius-sm: 4px;
                    --radius-md: 4px;
                    --radius-lg: 4px;
                    --radius-pill: 30px;
                }
            `}</style>
            <Switch>
                {oldPublicRoutes.map((route, idx) => (
                    <AppRoute
                        key={idx}
                        path={route.path}
                        layout={NonAuthLayout}
                        component={route.component}
                        isAuthProtected={false}
                    />
                ))}
                {oldAuthProtectedRoutes.map((route, idx) => (
                    <AppRoute
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        layout={VerticalLayout}
                        component={route.component}
                        isAuthProtected={true}
                    />
                ))}
            </Switch>
        </div>
    );
}
